import { createContext } from 'preact'

const Essentials = createContext({})

export default Essentials
